export const ROLES_GERAR_DOCUMENTO: string[] = ['admin' , 'colaborador_satya', 'colaboradores_satya_comercial' ]
